export default __webpack_public_path__ + "static/dacs04-da068c2f9c91c8e6877a3308768bf183.jpg";